// @ts-nocheck
import { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select' // https://react-select.com/props
import _ from 'lodash'
import { colors } from '@lmc/common/constants'
import Switch from 'react-switch'
import { css, StyleSheet } from 'aphrodite/no-important'
import styled from 'styled-components'
import { sortList } from '../../../common/utils'
import { ResidentSelectOption } from '../../generic'
import { Text } from '@lmc/ui-kit/src/general'

export default class TodoAssigneeSelector extends Component {
  constructor(props) {
    super(props)
    this.toggleValue = this.toggleValue.bind(this)
    this.toggleTaskType = this.toggleTaskType.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.assignAll = this.assignAll.bind(this)
  }

  handleSelectChange({ selection, key }) {
    this.props.setFormField({
      key,
      value: selection.map((option) => option.id)
    })
  }

  assignAll(key) {
    const {
      data: { carers, residents },
      setFormField
    } = this.props
    const list = key === 'assignee' ? carers : residents
    const filter =
      list === carers
        ? { active: true }
        : ({ status }) => ['active', 'dummy'].includes(status)
    setFormField({
      key,
      value: _(list).sortBy('name').filter(filter).map('id').value()
    })
  }

  toggleValue(key) {
    const { fields } = this.props
    this.props.setFormField({
      key,
      value: !fields[key]
    })
  }

  toggleTaskType() {
    const { taskType } = this.props.fields
    this.props.setFormField({ key: 'assignee', value: '' })
    this.props.setFormField({ key: 'resident', value: '' })
    this.props.setFormField({
      key: 'taskType',
      value: taskType === 'home' ? 'resident' : 'home'
    })
  }

  render() {
    const {
      data,
      fields: {
        resident,
        assignee,
        doubleSignature,
        taskType,
        logScreenPrompt,
        item
      },
      leftAlign,
      noTitle,
      testId
    } = this.props
    const isHomeType = taskType === 'home'
    const preferredPeopleNominative =
      this.props.features.preferredPeopleNominative || 'Residents'
    return (
      <div
        style={{
          margin: leftAlign ? null : 20,
          textAlign: leftAlign ? 'left' : 'center'
        }}
        data-testid={testId || 'todo-assignee-selector'}
      >
        {!noTitle && (
          <h2
            style={{
              textAlign: leftAlign ? 'left' : 'center',
              marginBottom: 0
            }}
            data-testid={
              testId ? `${testId}-title` : 'todo-assignee-selector-title'
            }
          >
            Who's it for
          </h2>
        )}
        <div
          style={{ marginBottom: 20 }}
          data-testid={
            testId
              ? `${testId}-task-type-toggle`
              : 'todo-assignee-selector-task-type-toggle'
          }
        >
          <ToggleButton
            onChange={this.toggleTaskType}
            offLabel={preferredPeopleNominative || 'Residents'}
            onLabel="Carers"
            onColor={colors.grey}
            checked={isHomeType}
            testId={
              testId
                ? `${testId}-task-type-button`
                : 'todo-assignee-selector-task-type-button'
            }
          />
        </div>
        <div
          className={css(classes.selectContainer)}
          style={{ margin: leftAlign ? null : '20px auto 0 auto' }}
          data-testid={
            testId
              ? `${testId}-selector-container`
              : 'todo-assignee-selector-selector-container'
          }
        >
          {isHomeType ? (
            <Selector
              label="Assign carers"
              sublabel="They will be responsible for completing this to-do"
              options={sortList(data.carers, { active: true })}
              onAssignAll={() => this.assignAll('assignee')}
              value={assignee}
              onChange={(selection) =>
                this.handleSelectChange({
                  selection,
                  key: 'assignee'
                })
              }
              leftAlign={leftAlign}
              testId={
                testId
                  ? `${testId}-carer-selector`
                  : 'todo-assignee-selector-carer-selector'
              }
            />
          ) : (
            <Selector
              label={`Assign ${preferredPeopleNominative.toLowerCase()}`}
              options={sortList(data.residents, ({ status }) =>
                ['active', 'dummy'].includes(status)
              )}
              onAssignAll={() => this.assignAll('resident')}
              value={resident}
              onChange={(selection) =>
                this.handleSelectChange({
                  selection,
                  key: 'resident'
                })
              }
              leftAlign={leftAlign}
              testId={
                testId
                  ? `${testId}-resident-selector`
                  : 'todo-assignee-selector-resident-selector'
              }
            />
          )}
        </div>
        <div
          data-testid={
            testId
              ? `${testId}-double-signature-section`
              : 'todo-assignee-selector-double-signature-section'
          }
        >
          <ToggleButton
            title="Require a second signature?"
            onChange={() => this.toggleValue('doubleSignature')}
            checked={doubleSignature}
            offLabel="No"
            onLabel="Yes"
            hideOffLabel
            value={doubleSignature}
            leftAlign={leftAlign}
            testId={
              testId
                ? `${testId}-double-signature-toggle`
                : 'todo-assignee-selector-double-signature-toggle'
            }
          />
        </div>
        {item && !isHomeType ? (
          <div
            data-testid={
              testId
                ? `${testId}-log-prompt-section`
                : 'todo-assignee-selector-log-prompt-section'
            }
          >
            <ToggleButton
              title={
                <>
                  <div>
                    <Text weight="bold">
                      Carer to add structured log after completion
                    </Text>
                  </div>
                  <div>
                    <ItalicText weight="bold">
                      Turn on to record data in reports and add additional
                      details about care.
                    </ItalicText>
                  </div>
                </>
              }
              onChange={() => this.toggleValue('logScreenPrompt')}
              checked={logScreenPrompt}
              offLabel="No"
              onLabel="Yes"
              hideOffLabel
              value={logScreenPrompt}
              leftAlign={leftAlign}
              testId={
                testId
                  ? `${testId}-log-prompt-toggle`
                  : 'todo-assignee-selector-log-prompt-toggle'
              }
            />
          </div>
        ) : null}
      </div>
    )
  }
}

const ToggleButton = ({
  title,
  hideOffLabel = false,
  checked,
  offLabel,
  onLabel,
  value,
  onChange,
  offColor = colors.grey,
  onColor = colors.green,
  leftAlign,
  testId
}) => {
  const noop = () => {}
  return (
    <div
      style={{ margin: leftAlign ? null : '0 auto' }}
      data-testid={testId || 'toggle-button'}
    >
      {title ? (
        <p
          className={css(classes.questionLabel)}
          data-testid={testId ? `${testId}-title` : 'toggle-button-title'}
        >
          {title}
        </p>
      ) : null}
      <br />
      <span
        style={{ cursor: 'pointer' }}
        onClick={onChange || noop}
        data-testid={
          testId
            ? `${testId}-switch-container`
            : 'toggle-button-switch-container'
        }
      >
        <span
          style={{
            paddingRight: 8,
            position: 'relative',
            top: -5,
            opacity: value && hideOffLabel ? 0 : 0.6
          }}
          data-testid={
            testId ? `${testId}-off-label` : 'toggle-button-off-label'
          }
        >
          {offLabel}
        </span>
        <Switch
          onChange={noop}
          checked={!!checked}
          onColor={onColor}
          offColor={offColor}
          handleDiameter={16}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={50}
          id="log-switch"
        />
        <span
          style={{
            paddingLeft: 8,
            position: 'relative',
            top: -5,
            opacity: value || !hideOffLabel ? 0.6 : 0
          }}
          data-testid={testId ? `${testId}-on-label` : 'toggle-button-on-label'}
        >
          {onLabel}
        </span>
      </span>
    </div>
  )
}

const Selector = ({
  label,
  onAssignAll,
  onChange,
  options,
  sublabel,
  value,
  testId
}) => {
  const formValues = value || []
  return (
    <div data-cy="resident-selector" data-testid={testId || 'selector'}>
      <div
        className={css(classes.selectTextContainer)}
        data-testid={testId ? `${testId}-header` : 'selector-header'}
      >
        <div className={css(classes.selectText)}>
          <span
            className={css(classes.selectLabelTitle)}
            data-testid={testId ? `${testId}-label` : 'selector-label'}
          >
            {label}
          </span>
          {sublabel && (
            <span
              className={css(classes.selectSublabel)}
              data-testid={testId ? `${testId}-sublabel` : 'selector-sublabel'}
            >
              {sublabel}
            </span>
          )}
        </div>
        <a
          data-cy="assign-all-btn"
          style={{ alignSelf: 'flex-end' }}
          onClick={onAssignAll}
          data-testid={testId ? `${testId}-assign-all` : 'selector-assign-all'}
        >
          Assign All
        </a>
      </div>
      <div data-testid={testId ? `${testId}-select` : 'selector-select'}>
        <Select
          classNamePrefix="lmc-select"
          closeMenuOnSelect={false}
          formatOptionLabel={ResidentSelectOption}
          getOptionLabel={({ name }) => name}
          getOptionValue={({ id }) => id}
          isMulti
          onChange={onChange}
          options={options}
          placeholder={null}
          value={options.filter((option) => formValues.includes(option.id))}
          inputProps={{
            'data-testid': testId ? `${testId}-select` : 'selector-select'
          }}
        />
      </div>
    </div>
  )
}

TodoAssigneeSelector.propTypes = {
  data: PropTypes.object.isRequired,
  fields: PropTypes.object,
  setFormField: PropTypes.func.isRequired,
  testId: PropTypes.string
}

const ItalicText = styled(Text)`
  font-style: italic;
`

const classes = StyleSheet.create({
  questionLabel: {
    fontWeight: 'bold',
    margin: '50px 0 0 0'
  },
  selectContainer: {
    maxWidth: 640,
    textAlign: 'left'
  },
  selectLabelTitle: {
    fontWeight: 'bold'
  },
  selectSublabel: {
    fontSize: 13
  },
  selectText: {
    display: 'flex',
    flexDirection: 'column',
    opacity: 0.7
  },
  selectTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0px 3px 5px 3px'
  }
})
